/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {KTSVG} from '../../../helpers'
import {getCSSVariableValue} from '../../../assets/ts/_utils'
import {Dropdown1} from '../../content/dropdown/Dropdown1'
import {AsideMenuItem} from '../../../layout/components/aside/AsideMenuItem'
import {AsideMenuItemWithSub} from '../../../layout/components/aside/AsideMenuItemWithSub'
import clsx from 'clsx'

type Props = {
  className: string
  chartColor: string
  strokeColor: string
  chartHeight: string
}
var asideMenuCSSClasses: string[] = []
const MixedWidget2: React.FC<Props> = ({className, chartColor, chartHeight, strokeColor}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(
      chartRef.current,
      chartOptions(chartHeight, chartColor, strokeColor)
    )
    if (chart) {
      chart.render()
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef])

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className={`card-header border-0 py-5 bg-${chartColor}`}>
        <h3 className='card-title fw-bolder text-white'>Master Data Management</h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body p-0'>
        {/* begin::Chart */}
        <div
          ref={chartRef}
          className={`mixed-widget-2-chart card-rounded-bottom bg-${chartColor}`}
        ></div>
        {/* end::Chart */}
        {/* begin::Stats */}
        <div className='card-p mt-n20 position-relative'>
          {/* begin::Row */}
          <div className='row g-0'>
            {/* begin::Col */}
            <div className='col bg-light-primary px-6 py-8 rounded-2 me-7  mb-7'>
              <KTSVG
                path='/media/icons/duotune/arrows/arr075.svg'
                className='svg-icon-3x svg-icon-primary d-block my-2'
              />
              <a href='#' className='text-primary fw-bold fs-4'>
                Job Standards
              </a>
              {/* <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/builder'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Layout Builder'
        fontIcon='bi-layers'
      /> */}
              <div
                id='#kt_aside_menu'
                data-kt-menu='true'
                className={clsx(
                  'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500',
                  asideMenuCSSClasses.join(' ')
                )}
              >
                <AsideMenuItem
                  to='/crafted/pages/categories/domain'
                  title='Activity Domain'
                  hasBullet={true}
                />
                <AsideMenuItem
                  to='/crafted/pages/categories/department'
                  title='Department'
                  hasBullet={true}
                />
                <AsideMenuItem to='/crafted/pages/categories/unit' title='Unit' hasBullet={true} />
                <AsideMenuItem
                  to='/crafted/pages/categories/process'
                  title='Process'
                  hasBullet={true}
                />
                <AsideMenuItem
                  to='/crafted/pages/categories/poste'
                  title='Poste'
                  hasBullet={true}
                />
              </div>
            </div>
            {/* end::Col */}
            {/* begin::Col */}
            <div className='col bg-light-primary px-6 py-8 rounded-2 me-7  mb-7'>
              <KTSVG
                path='/media/icons/duotune/arrows/arr075.svg'
                className='svg-icon-3x svg-icon-primary d-block my-2'
              />
              <a href='#' className='text-primary fw-bold fs-4'>
                Job Seekers Profile
              </a>
              <div
                id='#kt_aside_menu'
                data-kt-menu='true'
                className={clsx(
                  'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500',
                  asideMenuCSSClasses.join(' ')
                )}
              >
                <AsideMenuItem to='/crafted/pages/data/skill' title='Skills' hasBullet={true} />
                <AsideMenuItem
                  to='/crafted/pages/data/contract_type'
                  title='Contract Types'
                  hasBullet={true}
                />
                <AsideMenuItem
                  to='/crafted/pages/data/university'
                  title='Universities'
                  hasBullet={true}
                />
                <AsideMenuItem to='/crafted/pages/data/diplome' title='Diplomes' hasBullet={true} />
                <AsideMenuItem
                  to='/crafted/pages/data/speciality'
                  title='Specialities'
                  hasBullet={true}
                />
                <AsideMenuItem
                  to='/crafted/pages/data/country'
                  title='Countries'
                  hasBullet={true}
                />
                <AsideMenuItem to='/crafted/pages/data/city' title='Cities' hasBullet={true} />
                <AsideMenuItem
                  to='/crafted/pages/data/company'
                  title='Companies'
                  hasBullet={true}
                />
              </div>
            </div>

            <div className='col bg-light-primary px-6 py-8 rounded-2 me-7  mb-7'>
              <KTSVG
                path='/media/icons/duotune/arrows/arr075.svg'
                className='svg-icon-3x svg-icon-primary d-block my-2'
              />
              <a href='#' className='text-primary fw-bold fs-4'>
                Job Offer Details
              </a>
              <div
                id='#kt_aside_menu'
                data-kt-menu='true'
                className={clsx(
                  'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500',
                  asideMenuCSSClasses.join(' ')
                )}
              >
                <AsideMenuItem
                  to='/crafted/pages/data/work_poste'
                  title='Job Types'
                  hasBullet={true}
                />
                <AsideMenuItem to='/crafted/pages/data/benefit' title='Benefits' hasBullet={true} />
              </div>
            </div>
            {/* end::Col */}
          </div>
          {/* end::Row */}
          {/* begin::Row */}
          {/* end::Row */}
        </div>
        {/* end::Stats */}
      </div>
      {/* end::Body */}
    </div>
  )
}

const chartOptions = (
  chartHeight: string,
  chartColor: string,
  strokeColor: string
): ApexOptions => {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const color = getCSSVariableValue('--bs-' + chartColor)

  return {
    series: [],
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: chartHeight,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: true,
        enabledOnSeries: undefined,
        top: 5,
        left: 0,
        blur: 3,
        color: strokeColor,
        opacity: 0.5,
      },
    },
    plotOptions: {},
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      opacity: 0,
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [strokeColor],
    },
    xaxis: {
      categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      crosshairs: {
        show: false,
        position: 'front',
        stroke: {
          color: borderColor,
          width: 1,
          dashArray: 3,
        },
      },
    },
    yaxis: {
      min: 0,
      max: 80,
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return '$' + val + ' thousands'
        },
      },
      marker: {
        show: false,
      },
    },
    colors: ['transparent'],
    markers: {
      colors: [color],
      strokeColors: [strokeColor],
      strokeWidth: 3,
    },
  }
}

export {MixedWidget2}
